<div class="header container-fluid">
  <div class="header-right">
    <a href="tel:+18778657873"><span>(877) 865 PURE</span></a>
  </div>
</div>
